/* eslint no-unused-vars: ["warn"] */

module.exports = ['$stateProvider', $stateProvider => $stateProvider

  .state('login', {
    parent: 'root',
    insecure: true,
    url: '/login?error&confirmNewEmailState&alreadyConfirmed',
    reloadOnSearch: false,
    resolve: {
      stateAlreadyLogged: [
        '$ngRedux',
        '$state',
        'SessionService',
        // Root state resolve dependency
        'stateSession',

        (
          $ngRedux,
          $state,
          SessionService,
          stateSession,
        ) => {
          if (SessionService.isInitialized() && SessionService.isPatientLoggedIn()) {
            const groupId = $ngRedux.getState().group.id;

            $state.go('patients.id.home', {
              groupId,
              patientId: SessionService.fetch().authenticatedPatientId,
            });
            return false;
          }
          return false;
        },
      ],
    },
    views: {
      'content@root': {
        template: '<login class="patient-bg">',
      },
    },
  })
  .state('activation', {
    parent: 'root',
    activated: true,
    url: '/activation',
    views: {
      'content@root': {
        template: '<activation class="patient-bg">',
      },
    },
  })
  .state('register', {
    parent: 'root',
    insecure: true,
    views: {
      'content@root': {
        template: '<register class="patient-bg">',
      },
    },
    url: '/register',
  })
  .state('forgotten_password', {
    parent: 'root',
    insecure: true,
    views: {
      'content@root': {
        template: '<forgot-password class="patient-bg">',
      },
    },
    url: '/forgot-password',
  })
  .state('reset_password', {
    parent: 'root',
    insecure: true,
    views: {
      'content@root': {
        template: '<reset-password class="patient-bg">',
      },
    },
    url: '/reset-password',
  }),
];



// WEBPACK FOOTER //
// ./signin/config/routes.js